var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://hytra3.github.io/hakli_glyph_recognizer/","frameborder":"0px","width":"100%","height":"100%","allowfullscreen":"true","mozallowfullscreen":"true","webkitallowfullscreen":"true"}},[_vm._v("Loading…")])
}
var staticRenderFns = []

export { render, staticRenderFns }